const actions = {
  resetPlayerState: 'RESET_PLAYER_STATE',
  createPlayer: 'CREATE_PLAYER',
  updatePlayer: 'UPDATE_PLAYER',
  listPlayer: 'LIST_PLAYER',
  getPlayer: 'GET_PLAYER',
  assignedPlayers: 'ASSIGNED_PLAYERS',
  getMyPlayers: 'GET_MY_PLAYERS',
  getSpecificPlayer: 'GET_SPECIFIC_PLAYER',
  resetSpecificPlayer: 'RESET_SPECIFIC_PLAYER',
};

export default actions;
